// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { footerContactUsContainerStyles } from "@steiner/App/Components/Footer/FooterContactUsContainer";
import { headerBackgroundCss } from "@steiner/App/PageExtensions/HeaderExtensions";
import { DivWrapper } from "@steiner/XDL/constants";
import { layoutContainer, xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

footerContactUsContainerStyles.container = {
    css: css`
        padding-top: 20px;
        padding-bottom: 20px;
        ${headerBackgroundCss}
    `,
};

footerContactUsContainerStyles.innerContainer = {
    css: css`
        display: grid;
        grid-template-columns: 1fr 317px;
        grid-template-rows: auto;
        gap: 20px 22px;
        ${layoutContainer}

        ${xScreen("lte", "md")} {
            grid-template-columns: auto;
        }
    `,
};

footerContactUsContainerStyles.leftSection = {
    css: css`
        grid-area: 1 / 1 / 2 / 2;
        & > ${DivWrapper} {
            display: flex;
            gap: 20px 22px;
            & > div {
                width: 100%;
                max-width: 317px;
            }
        }

        ${xScreen("lte", "md")} {
            grid-area: 1 / 1 / 2 / 2;
            & > ${DivWrapper} {
                & > div {
                    max-width: initial;
                    flex: 1;
                }
            }
        }

        ${xScreen("lt", "sm")} {
            & > ${DivWrapper} {
                flex-direction: column;
            }
        }
    `,
};

footerContactUsContainerStyles.rightSection = {
    css: css`
        grid-area: 1 / 2 / 2 / 3;
        ${xScreen("lte", "md")} {
            grid-area: 2 / 1 / 3 / 2;
        }
    `,
};
